import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/common/Button';

const CancelCard = ({ cancelCardAction = () => {}, abortAction = () => {} }) => (
  <div className="modal">
    <h2 className="modal__header">Cancel Card</h2>
    <p className="modal__paragraph">
      Please confirm that you would like to cancel the card currently linked to your account.
    </p>
    <div className="modal__button-line">
      <Button className="modal__button" onClick={cancelCardAction}>Cancel Card</Button>
      <Button className="modal__button" onClick={abortAction}>Don't Cancel</Button>
    </div>
  </div>
);

CancelCard.propTypes = {
  cancelCardAction: PropTypes.func,
  abortAction: PropTypes.func
};

export default CancelCard;
